const destinations = [
  {
    name: "United Kingdom (Aberdeen, London)",
    context: "North Sea offshore contracts, platform rotations, diving supervisor assignments; also London business travel",
    urgency: "Contract mobilization can arrive with 48–72 hours notice",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Nigeria & West Africa",
    context: "Offshore platform rotations to the Niger Delta, Angola deepwater, and Equatorial Guinea LNG projects",
    urgency: "International offshore contracts often have 7–14 day mobilization windows",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Singapore & Malaysia",
    context: "Marine fabrication deliveries, ROV operations, diving contracts in the South China Sea and Malacca Strait",
    urgency: "Vessel crew changes and equipment deliveries run on fixed schedules — missing one is costly",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Caribbean & Bahamas",
    context: "New Orleans cruise departures, family vacations, Mardi Gras and holiday sailings from NOLA Port",
    urgency: "Last-minute cruise bookings frequently create 2–4 week passport urgency windows",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Brazil (Santos, Rio)",
    context: "Pre-salt deepwater platform rotations, subsea equipment deliveries, Petrobras contract work",
    urgency: "Brazilian visa + valid passport both required — double the timeline risk",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "France & Quebec",
    context: "Cajun cultural heritage tourism, Nicholls State culinary exchange programs, family genealogy trips",
    urgency: "Culinary program deadlines and heritage tours operate on fixed departure dates",
    icon: "ri-map-pin-2-line",
  },
];

const stats = [
  { stat: "72 hrs", label: "Shortest offshore contract mobilization window we have accommodated for a Houma oilfield worker" },
  { stat: "60%", label: "of Houma expedited passport requests are related to offshore, maritime, or energy industry travel" },
  { stat: "5 Days", label: "average processing time for renewing an offshore worker's passport when standard mail processing would take months" },
  { stat: "Nov–Jan", label: "peak season when holiday cruises and Mardi Gras sailings collide with offshore contract renewals" },
];

export default function HoumaDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Houma Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from Bayou Region clients. Understanding local travel behavior is part of why our document review catches issues before they derail your offshore rotation or maritime contract.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {stats.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Louisiana Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We serve travelers across Louisiana with the same expedited passport processing expertise. Looking for service in another community?
              </p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              {[
                { name: "New Orleans", href: "/new-orleans" },
                { name: "Baton Rouge", href: "/baton-rouge" },
                { name: "Lafayette", href: "/lafayette" },
                { name: "Lake Charles", href: "/lake-charles" },
              ].map((link) => (
                <a key={link.href} href={link.href} className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                  {link.name} <i className="ri-arrow-right-line text-xs"></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}